import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  DEV_DARK_MODE_EVENT,
  isDevDarkModeEnabled,
} from '../utils/devDarkMode.js';

export default function DevSkeleton(props) {
  const [isDark, setIsDark] = useState(() => isDevDarkModeEnabled());

  useEffect(() => {
    const sync = () => setIsDark(isDevDarkModeEnabled());
    window.addEventListener(DEV_DARK_MODE_EVENT, sync);
    return () => window.removeEventListener(DEV_DARK_MODE_EVENT, sync);
  }, []);

  const darkProps = isDark
    ? {
        baseColor: '#1f2937',
        highlightColor: '#4b5563',
      }
    : {
        baseColor: '#ebebeb',
        highlightColor: '#f5f5f5',
      };

  return <Skeleton {...darkProps} {...props} />;
}
